export const minecraft1201 = {
  version: '1.20.1',
  title: 'Trails & Tales',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Vanilla-PMP_Collection-Carousel-0_Trails-and-Tales_1280x768.jpg',
  releases: [
    {
      id: "130iZ2Xwk",
      version: "1.0.4",
      date: "Jul 5, 2025",
      changelog: "Versión estable para Minecraft 1.20.1 con todos los mods optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.20.1",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};